import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
} from "react";
import SnLabel from "@shared/components/SnLabel";
import SnComboBox from "@shared/components/SnComboBox";
import SnTextBox from "@shared/components/SnTextBox";

export interface Popup002Ref {
  checkValidity: () => Promise<{ flag: boolean; message?: string }>;
  getSelectedValue: () => Promise<any>;
}

const SN_SFA_ISSUE_REG_004_POP_002 = forwardRef<Popup002Ref>((props, ref) => {
  const menuCode = useRef<string>("");
  const serverCode = useRef<string>("DEV");

  useImperativeHandle(ref, () => ({
    async checkValidity() {
      if (!menuCode.current) {
        return { flag: false, message: "메뉴 코드를 선택해 주세요." };
      }

      if (!serverCode.current) {
        return { flag: false, message: "가져올 서버를 선택해 주세요." };
      }

      return { flag: true };
    },

    async getSelectedValue() {
      return {
        menuCode: menuCode.current,
        serverCode: serverCode.current,
      };
    },
  }));

  return (
    <div className="flex flex-col w-full">
      <div className="relative flex space-x-2">
        <SnLabel text="메뉴 코드" type="string" />
        <div className="flex-1">
          <SnTextBox
            onValueChanged={(val) => menuCode.current = val}
          />
        </div>
      </div>

      <div className="relative flex space-x-2 mt-2">
        <SnLabel text="가져올 서버" type="string" />
        <div className="flex-1">
          <SnComboBox
            defaultValue={"DEV"}
            js_combo={[
              { code: "DEV", name: "개발" },
              { code: "PRD", name: "운영" },
            ]}
            onValueChanged={(val) => serverCode.current = val}
          />
        </div>
      </div>
    </div>
  );
});

export default SN_SFA_ISSUE_REG_004_POP_002;
